import React from 'react';
import { buildSrcSet } from '../utils/responsiveImages';

const ResponsiveImage = ({
    image = null,
    src = null,
    alt = '',
    sizes = '100vw',
    loading = 'lazy',
    fetchPriority,
    className,
    imgClassName,
    ...imgProps
}) => {
    const fallbackSrc = src || image?.src;
    const variants = image?.variants || {};
    const avifSrcSet = buildSrcSet(variants.avif);
    const webpSrcSet = buildSrcSet(variants.webp);

    if (!fallbackSrc) {
        return null;
    }

    return (
        <picture className={className}>
            {avifSrcSet && <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} />}
            {webpSrcSet && <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />}
            <img
                src={fallbackSrc}
                alt={alt || image?.alt || ''}
                loading={loading}
                decoding={loading === 'eager' ? 'sync' : 'async'}
                fetchPriority={fetchPriority}
                width={image?.width}
                height={image?.height}
                className={imgClassName}
                {...imgProps}
            />
        </picture>
    );
};

export default ResponsiveImage;
